//zh 中文语言包
export default {
 language: 'cn'
}